export default "__VITE_ASSET__DCYQ$7bM__"